import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationData as Notification } from '../../utilities/interfaces/NotificationData';

// represents the shape of the slice in state
interface NotificationState {
  value: any;
}

const initialState: NotificationState = {
  value: {},
};


const notificationSlice = createSlice({
  name: 'stateDraft',
  initialState,
  reducers: {
    // add new Draft item
    addNotificationItem(state, action: PayloadAction<Notification>) {
      // its okay to do this because immer makes it immutable
      state.value = action.payload;
    },
    removeNotificationItem(state) {
      state.value = {};
    },
  },
});

export const { addNotificationItem, removeNotificationItem } = notificationSlice.actions;
export default notificationSlice.reducer;
